export enum CollectionRouteTypes {
    publicCollections = 'public-collections',
    privateCollections = 'my-collections',
}

export enum CollectionTypes {
    publicCollections = 'public',
    privateCollections = 'private',
}
